// AddSubscription.jsx
import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { peoplePlansQA, peoplePlansProduction } from './plans'
import useSubscriptionStore from '../SubscriptionStore'
import CircularProgress from '@material-ui/core/CircularProgress'
import useEscapeKey from '../../../utils/useEscapeKey'
// import { getAccount } from '../../../../Api/index'
// import { useQuery } from 'react-query'

export default function AddSubscription ({
  onContinue,
  isLoading,
  handleCloseOnClick
}) {
  const [isVisible, setIsVisible] = useState(false)
  const [isYearly, setIsYearly] = useState(false)
  const { selectedPlan, setSelectedPlan, isModalHidden } =
    useSubscriptionStore()
  const [isLoadingInternality, setIsLoadingInternality] = useState(false)
  // const { data: AccountData } = useQuery('account', getAccount)

  // Determine the environment based on hostname
  const isQAEnvironment =
    window.location.hostname.includes('qa') ||
    window.location.hostname === 'localhost'

  // Dynamically select plans
  const peoplePlans = isQAEnvironment ? peoplePlansQA : peoplePlansProduction

  const filteredPlans = (
    isYearly
      ? peoplePlans
          .filter(plan => plan.yearlyPrice !== 'Free')
          .map(plan => ({
            ...plan,
            id: plan.yearlyId,
            price: plan.yearlyPrice
          }))
      : peoplePlans
  ).filter(plan => !plan.name.toLowerCase().includes('unlimited'))

  const getBoxStyle = planId => {
    return planId === selectedPlan
      ? styles.SelectedBoxProperty
      : styles.BoxProperty
  }

  const handlePlanClick = planId => {
    setSelectedPlan(planId === selectedPlan ? null : planId)
  }

  // Trigger the slide-in effect when the component mounts
  useEffect(() => {
    const timeoutId = setTimeout(() => setIsVisible(true), 1)
    return () => clearTimeout(timeoutId)
  }, [])

  const handleClose = e => {
    e.stopPropagation()
    setTimeout(() => {
      if (handleCloseOnClick) handleCloseOnClick()
    }, 250)
    setIsVisible(false)
  }

  useEscapeKey(e => handleClose(e))

  const handleContinue = e => {
    e.stopPropagation()
    //  const isAdmin = AccountData?.data?.role === 'admin'
    //  if (isAdmin) {
    //   console.log("handleContinue AddSubsciption")
    //   setIsVisible(false)
    //   if (onContinue) onContinue()
    //  }
    if (selectedPlan) {
      if (onContinue) onContinue()
      setIsLoadingInternality(true)
    }
  }

  useEffect(() => {
    if (isModalHidden) {
      setIsVisible(false)
    }
  }, [isModalHidden])

  return (
    <div className={styles.modalBackdrop} onClick={handleClose}>
      {/*  */}
      <div
        className={styles.modalContent}
        style={{ transform: isVisible ? 'translateX(0)' : 'translateX(100%)' }}
        onClick={e => e.stopPropagation()}
      >
        <h1 className={styles.titleH1Subscription}>
          Add People Data Subscription
        </h1>
        <p className={styles.PSubscription}>
          You'll need to add a people data subscription to see this record.
          Choose the subscription tier you want from the options below.
        </p>

        <div className={styles.FirstContainerAddSubscription}>
          <h2 className={styles.H2PeopleDataSubscription}>
            People data subscription
          </h2>
          <div className={styles.PricingToggle}>
            <span
              className={!isYearly ? styles.Active : styles.Inactive}
              onClick={() => setIsYearly(false)}
            >
              Monthly
            </span>
            <span
              className={isYearly ? styles.Active : styles.Inactive}
              onClick={() => setIsYearly(true)}
            >
              Annual
            </span>
          </div>
        </div>

        {/* Render plan options */}
        <div className={styles.plansContainer}>
          {filteredPlans.map(plan => (
            <div
              key={plan.id}
              className={getBoxStyle(plan.id)}
              onClick={() => handlePlanClick(plan.id)}
            >
              <div className={styles.BoxPropertyDirection}>
                <span
                  className={
                    plan.id === selectedPlan
                      ? styles.SelectedSpanTitleBoxProperty
                      : styles.SpanTitleBoxProperty
                  }
                >
                  {plan.name}
                </span>
                <span
                  className={
                    plan.id === selectedPlan
                      ? styles.SelectSpanBoxProperty
                      : styles.SpanBoxProperty
                  }
                >
                  {plan.records}
                </span>
              </div>
              <div className={styles.BoxPropertySpacing}>
                <div>
                  <span
                    style={{ display: 'block' }}
                    className={
                      plan.id === selectedPlan
                        ? styles.SelectSpanBoxProperty
                        : styles.SpanBoxProperty
                    }
                  >
                    {plan.price}
                  </span>
                  <span
                    className={
                      plan.id === selectedPlan
                        ? styles.SelectSpanBoxProperty
                        : styles.SpanBoxProperty
                    }
                  >
                    per {isYearly ? 'year' : 'month'}
                  </span>
                </div>
                <div>
                  <span
                    className={
                      plan.id === selectedPlan
                        ? styles.SelectSpanBoxProperty
                        : styles.SpanBoxProperty
                    }
                  >
                    {selectedPlan === plan.id ? 'Selected' : 'Select'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Continue Button */}
        <button
          disabled={!selectedPlan || isLoading || isLoadingInternality}
          className={styles.buttonSettingsUpdate}
          onClick={handleContinue}
        >
          {isLoading || isLoadingInternality ? (
            <CircularProgress size={20} style={{ color: 'white' }} />
          ) : (
            'Continue'
          )}
        </button>
      </div>
    </div>
  )
}
